import { CircularProgress, Skeleton } from "@mui/material";
import { Box } from "@mui/system";
import React, { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ZoomableGroup, ComposableMap, Geographies, Geography } from "react-simple-maps";
import { getAllCustomers } from "../../actions/customers";
// https://www.react-simple-maps.io/examples/map-chart-with-tooltip/
const geoUrl =
  "https://raw.githubusercontent.com/deldersveld/topojson/master/world-countries.json";

const rounded = (num) => {
  if (num > 1000000000) {
    return Math.round(num / 100000000) / 10 + "Bn";
  } else if (num > 1000000) {
    return Math.round(num / 100000) / 10 + "M";
  } else {
    return Math.round(num / 100) / 10 + "K";
  }
};

const MapChart = ({ setTooltipContent }) => {
  const dispatch = useDispatch();

  const customerList = useSelector((state) => state.customerList);
  const candidateList = useSelector((state) => state.candidateList);
  
  const [categorisedByCountry, setCategorisedByCountry] = useState([]);
  const [mapLodading, setMapLodading] = useState(true);
  const { loading, error, customers } = customerList;
  const [data, setData] = React.useState([]);

  useEffect(() => {
    const getCountries = async () => {
      if (customers === null) {
        dispatch(getAllCustomers());
      }
      setCategorisedByCountry(
        customers?.reduce(function (r, a) {
          r[a.des_country] = r[a.des_country] || [];
          r[a.des_country].push(a);
          return r;
        }, Object.create(null))
      );
      for (var key in categorisedByCountry) {
        categorisedByCountry[key] = categorisedByCountry[key]?.length;
      }
      const getCountriesData = () => {
        const geoDataFromStorage = localStorage.getItem("geo_data");
        if (geoDataFromStorage === null) {
          fetch(geoUrl)
            .then((response) => response.json())
            .then((responseJson) => {
              localStorage.setItem("geo_data", JSON.stringify(responseJson));
              const geos = responseJson.objects.countries1.geometries;
              for (var i = 0; i < geos.length; i++) {
                if (geos[i].properties.NAME in categorisedByCountry) {
                  geos[i].properties.POP_EST = categorisedByCountry[geos[i].properties.NAME];
                } else {
                  geos[i].properties.POP_EST = 0;
                }
              }
              responseJson.objects.countries1.geometries = geos;
              setData(responseJson);
              setMapLodading(false);
            })
            .catch((error) => {});
        } else {
          var temp = JSON.parse(geoDataFromStorage);
          console.log(temp)
          const geos = temp.objects.countries1.geometries;
          for (var i = 0; i < geos.length; i++) {
            if (geos[i].properties.NAME in categorisedByCountry) {
              geos[i].properties.POP_EST = categorisedByCountry[geos[i].properties.NAME];
            } else {
              geos[i].properties.POP_EST = 0;
            }
          }
          temp.objects.countries1.geometries = geos;
          setData(temp);
          setMapLodading(false);
        }
      };

      getCountriesData();
    };
    if (categorisedByCountry?.length === 0) {
      getCountries();
    }
  }, [categorisedByCountry]);
  return (
    <>
      {mapLodading && (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Skeleton variant="rectangular" width={410} height={330} />
        </Box>
      )}
      {!mapLodading && (
        <ComposableMap data-tip="" projectionConfig={{ scale: 200 }}>
          <ZoomableGroup>
            <Geographies geography={data}>
              {({ geographies }) =>
                geographies?.map((geo) => (
                  <Geography
                    key={geo.rsmKey}
                    geography={geo}
                    onMouseEnter={() => {
                      const { NAME, POP_EST } = geo.properties;

                      setTooltipContent(`${NAME} — ${POP_EST}`);
                    }}
                    onMouseLeave={() => {
                      setTooltipContent("");
                    }}
                    style={{
                      default: {
                        fill: "#D6D6DA",
                        outline: "none",
                      },
                      hover: {
                        fill: "#F53",
                        outline: "none",
                      },
                      pressed: {
                        fill: "#E42",
                        outline: "none",
                      },
                    }}
                  />
                ))
              }
            </Geographies>
          </ZoomableGroup>
        </ComposableMap>
      )}
    </>
  );
};

export default memo(MapChart);
